import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { openDialog } from '../redux/navigation'
import { theme } from "../theme";

export default function AlertDialog(props) {
  const { title = false, open, txt, neg, pos, noLabel, yesLabel} = openDialog()
  const { colors } = theme
  return (
    <div>
      <Dialog
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{ title ? title: "Are you sure?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {txt}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          { neg !== null &&
            <Button 
              onClick={neg} 
              variant="contained"
              size="large"
              style={{ 
                backgroundColor: colors.primary,
                color: colors.light
              }}
            >
              { noLabel ? noLabel: "No"}
            </Button>
          }
          {
            pos !== null &&
            <Button onClick={pos} color="primary" autoFocus>
              { yesLabel ? yesLabel : "Yes, Do it!"}
            </Button>
          }
        </DialogActions>
      </Dialog>
    </div>
  );
}